import { useContext } from 'react';
import { LanguageContext } from './LanguageContext';
import { translations, type TranslationKey } from './translations';

// ─────────────────────────────────────────────────────────────────────────────
// Hook
// ─────────────────────────────────────────────────────────────────────────────

export function useTranslation() {
  const { language, setLanguage } = useContext(LanguageContext);

  /** Translate a key to the current language. Returns empty string if key is undefined to allow fallbacks. */
  const t = (key: TranslationKey | string): string => {
    const entry = translations[key as TranslationKey];
    return entry ? entry[language] : '';
  };

  return { t, language, setLanguage };
}
